import useUser from "../user/useUser";
import { useEffect } from "react";
import { getFollowingCoaches, getSpecialists } from "../../api/coaches";
import { useBlogNavigationContext } from "../../components/blog/blogsPage/blogTabs";

export const useFollowingCoachesCoachCard = () => {
  const { user } = useUser();
  const { dispatch } = useBlogNavigationContext();

  useEffect(() => {
    const getFollowing = async () => {
      if (user.token) {
        const data = await Promise.all([
          getFollowingCoaches(user.token),
          getSpecialists(),
        ]);
        const followingCoaches = data[0];
        const coaches = data[1];
        dispatch({ followingCoaches: followingCoaches, coaches: coaches });
      }
    };

    void getFollowing();
  }, [dispatch, user?.token]);
};
